import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CampaignService } from '../campaign/campaign.service';
import { Master } from './master.model';
import { MasterService } from './master.service';

@Component({
    selector: 'jhi-master-detail',
    templateUrl: './master-detail.component.html'
})
export class MasterDetailComponent implements OnInit, OnDestroy {

    master: Master;
    private subscription: Subscription;
    isSaving: boolean;
    modifiedPVR: number;

    constructor(
        private masterService: MasterService,
        private route: ActivatedRoute,
        public campaignService: CampaignService
    ) {
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load(id) {
        this.masterService.find(id).subscribe(master => {
            this.master = master;
            this.modifiedPVR = this.master.residualVacantPlaces;
        });
    }

    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/master-detail.component.ts